
import React from "react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { LineChartIcon, PieChartIcon } from "lucide-react";
import PieChartDisplay from "../charts/PieChartDisplay";
import LineChartDisplay from "../charts/LineChartDisplay";

interface BreukTransportTabProps {
  transportDamageData: any[];
  transportDamageTrendData: any[];
}

const BreukTransportTab: React.FC<BreukTransportTabProps> = ({
  transportDamageData,
  transportDamageTrendData
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <div className="space-y-1">
            <CardTitle className="text-base">Transportschade per vervoerder</CardTitle>
            <CardDescription>Verdeling van transportschade per vervoerder</CardDescription>
          </div>
          <PieChartIcon className="h-5 w-5 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <PieChartDisplay data={transportDamageData} />
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <div className="space-y-1">
            <CardTitle className="text-base">Trend in transportschade</CardTitle>
            <CardDescription>Ontwikkeling van schadegevallen over tijd</CardDescription>
          </div>
          <LineChartIcon className="h-5 w-5 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <LineChartDisplay
            data={transportDamageTrendData}
            dataKey="schades"
            nameKey="month"
            lineName="Aantal schades"
            color="#FF3B30"
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default BreukTransportTab;
